import { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import parse from 'html-react-parser';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  image: {
    width: '100%',
    maxWidth: 600,
    maxHeight: 450,
    marginLeft: 32,
    marginBottom: 32,
    float: 'right',
    '@media screen and (max-width: 825px)': {
      marginLeft: 0,
      float: 'none',
    },
  },
});

const SejarahPerusahaan = ({ isId }: any) => {
  const classes = useStyles();
  const [sejarahPerusahaanState, setSejarahPerusahaanState] =
    useState<any>(null);
  const [loadingState, setLoadingState] = useState(true);

  const getData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content/title/Sejarah%20Perusahaan`
      );
      const resJson = await res.json();
      setSejarahPerusahaanState(resJson.data);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div
      style={{
        maxWidth: 1280,
        margin: '0 auto',
        padding: '0 16px',
        paddingBottom: '5rem',
      }}
    >
      {loadingState ? (
        <>
          <Skeleton
            variant='rect'
            style={{ maxWidth: 300, height: 24, marginBottom: '4rem' }}
          />
          <Skeleton
            variant='rect'
            style={{ maxWidth: 500, height: 42, marginBottom: '4rem' }}
          />
        </>
      ) : (
        <>
          <Typography style={{ marginBottom: '4rem' }}>
            {isId ? 'Tentang Kami' : 'About Us'}
            &nbsp; &gt; &nbsp;{' '}
            <span style={{ color: '#e3232a' }}>
              {isId ? 'Sejarah Perusahaan' : 'Company History'}
            </span>
          </Typography>
          <Typography
            color='primary'
            variant='h4'
            style={{ marginBottom: '4rem' }}
          >
            {isId
              ? sejarahPerusahaanState.title_id
              : sejarahPerusahaanState.title_en}
          </Typography>
        </>
      )}
      {sejarahPerusahaanState?.image ? (
        <img
          src={`${process.env.REACT_APP_URL}/images/${sejarahPerusahaanState?.image}`}
          alt='img about us'
          className={classes.image}
        />
      ) : loadingState ? (
        <div />
      ) : (
        <div className={classes.image} />
      )}

      <div id='content'>
        {loadingState ? (
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <Skeleton variant='text' />
              <Skeleton variant='text' />
              <Skeleton variant='text' />
              <Skeleton variant='text' />
              <Skeleton variant='text' />
              <Skeleton variant='text' />
              <Skeleton variant='text' />
            </div>
            <Skeleton variant='rect' style={{ width: '50%', height: 150 }} />
          </div>
        ) : (
          parse(
            isId
              ? sejarahPerusahaanState.content_id
              : sejarahPerusahaanState.content_en
          )
        )}
      </div>
    </div>
  );
};

export default SejarahPerusahaan;
